import { __assign, __rest } from "tslib";
import React from 'react';
import VeltUserSelectorDropdownAvatar from './VeltUserSelectorDropdownAvatar/VeltUserSelectorDropdownAvatar';
import VeltUserSelectorDropdownEmail from './VeltUserSelectorDropdownEmail/VeltUserSelectorDropdownEmail';
import VeltUserSelectorDropdownErrorIcon from './VeltUserSelectorDropdownErrorIcon/VeltUserSelectorDropdownErrorIcon';
import VeltUserSelectorDropdownName from './VeltUserSelectorDropdownName/VeltUserSelectorDropdownName';
import { transformWireframeProps } from '../../utils/propUtils';
var VeltUserSelectorDropdown = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-user-selector-dropdown-wireframe", __assign({}, transformedProps), children));
};
VeltUserSelectorDropdown.Avatar = VeltUserSelectorDropdownAvatar;
VeltUserSelectorDropdown.Email = VeltUserSelectorDropdownEmail;
VeltUserSelectorDropdown.ErrorIcon = VeltUserSelectorDropdownErrorIcon;
VeltUserSelectorDropdown.Name = VeltUserSelectorDropdownName;
export default VeltUserSelectorDropdown;
